import { render } from "./PageHistorique.vue?vue&type=template&id=122fb918&scoped=true"
import script from "./PageHistorique.vue?vue&type=script&lang=js"
export * from "./PageHistorique.vue?vue&type=script&lang=js"

import "./PageHistorique.vue?vue&type=style&index=0&id=122fb918&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122fb918"]])

export default __exports__